import type { ReactNode } from "react";
import { create } from "zustand";

/**
 * What the current screen is, for the top bar. Screens declare it with
 * <PageHeader>; the header shows it, so no screen spends a band of height on
 * its own title.
 */
/** `kicker`: a mono line beside the name ("MON 12/10 · 18:43 · KATHKUNI"). */
export type PageMeta = { index?: string; eyebrow: string; kicker?: string; lede?: ReactNode; tone?: "rhodo" };

export const usePageMeta = create<{ meta: PageMeta | null; set: (m: PageMeta | null) => void }>((set) => ({
  meta: null,
  set: (meta) => set({ meta }),
}));
